"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchBarFilter = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons/");
var _SelectFilter = _interopRequireDefault(require("./SelectFilter"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

const SearchBarFilter = props => {
  const {
    filterHelperText,
    handleSearchTerm,
    searchPlaceHolder,
    filterOptions,
    defaultFilterOption,
    inputWrapperClass,
    isToHide,
    responsiveHidden,
    handleShowSearch,
    handleHideSearch,
    isShowSearch,
    isShowHelperText
  } = props;
  const [isTyping, setIsTyping] = (0, _react.useState)(false);
  const [inputValue, setInputValue] = (0, _react.useState)('');
  const [filterOption, setFilterOption] = (0, _react.useState)(defaultFilterOption);
  const [clicked, setClicked] = (0, _react.useState)(false);
  const saraivaTheme = (0, _core.useTheme)();
  const isDesktop = (0, _core.useMediaQuery)(saraivaTheme.breakpoints.up('sm'));
  const classes = (0, _styles.default)();
  const handleOnSubmit = filter => {
    if (!isDesktop) {
      handleHideSearch();
    }
    handleSearchTerm({
      filterTerm: inputValue,
      filterName: filter.value || defaultFilterOption
    });
  };
  const handleOnKeyDown = evt => {
    if (evt.key === 'Enter') {
      handleOnSubmit(filterOption);
    }
  };
  const clearSearch = () => {
    setIsTyping(!isTyping);
    setInputValue('');
    handleHideSearch();
  };
  const handleSearchChange = evt => {
    setInputValue(evt && evt.target.value);
    if (evt && evt.target.value === '') {
      setIsTyping(false);
      handleHideSearch();
      return;
    }
    if (!isTyping) {
      setIsTyping(true);
    }
  };
  const handleOnClickInput = event => {
    const nodes = ['button', 'svg', 'path', 'span'];
    if (nodes.indexOf(event.target.localName) === -1) {
      handleShowSearch();
    }
  };
  const goBack = () => {
    setIsTyping(false);
    handleHideSearch();
    setInputValue('');
  };
  const handleClassActive = () => {
    setClicked(!clicked);
  };
  if (isToHide) return null;
  const searchIcon = /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
    position: "start"
  }, /*#__PURE__*/_react.default.createElement(_icons.SearchSharp, {
    className: classes.adornment
  }));
  const backIcon = /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
    position: "start"
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: goBack,
    className: classes.buttonAdornment
  }, /*#__PURE__*/_react.default.createElement(_icons.ArrowBack, {
    className: classes.adornmentBack
  })));
  const closeIcon = /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
    position: "end"
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: clearSearch,
    className: classes.closeButton
  }, /*#__PURE__*/_react.default.createElement(_icons.Close, {
    className: classes.adornmentRight
  })));
  return /*#__PURE__*/_react.default.createElement(_core.Hidden, responsiveHidden, isDesktop ? /*#__PURE__*/_react.default.createElement("div", {
    className: classes.filterContainer
  }, /*#__PURE__*/_react.default.createElement("form", {
    className: `${classes.searchWrapper} ${inputWrapperClass} ${isShowHelperText === true ? classes.errorForm : ''} ${clicked ? `${classes.searchActive}` : classes.search} `,
    onKeyDown: handleOnKeyDown,
    onClick: handleClassActive
  }, /*#__PURE__*/_react.default.createElement(_SelectFilter.default, {
    filterOptions: filterOptions,
    onOptionSelect: setFilterOption,
    option: filterOption
  }), /*#__PURE__*/_react.default.createElement(_core.Input, {
    disableUnderline: true,
    placeholder: searchPlaceHolder,
    onChange: handleSearchChange,
    value: inputValue,
    className: classes.input,
    startAdornment: searchIcon,
    endAdornment: isTyping || inputValue !== '' ? closeIcon : null
  })), isShowHelperText === true && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.FormHelperText, {
    style: {
      color: '#A42B31'
    }
  }, filterHelperText))) : /*#__PURE__*/_react.default.createElement("form", {
    className: `${classes.searchWrapper} ${inputWrapperClass}`,
    onSubmit: e => e.preventDefault(),
    onKeyDown: handleOnKeyDown
  }, /*#__PURE__*/_react.default.createElement(_core.Input, {
    id: "input-search-filter-mobile",
    disableUnderline: true,
    placeholder: searchPlaceHolder,
    onChange: handleSearchChange,
    value: inputValue,
    onClick: handleOnClickInput,
    className: classes.input,
    startAdornment: isShowSearch ? backIcon : searchIcon,
    endAdornment: isTyping || inputValue !== '' ? closeIcon : null
  }), isShowSearch && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.menuContainer
  }, filterOptions && inputValue.length && filterOptions.map((filter, index) => {
    const {
      label
    } = filter;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      style: {
        marginTop: index < 2 && 24
      },
      className: classes.filterItem,
      onClick: () => handleOnSubmit(filter)
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "body2",
      className: classes.filterValue
    }, inputValue), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.filterLabel
    }, `em ${label}`)), /*#__PURE__*/_react.default.createElement(_core.Divider, {
      className: classes.divider
    }));
  }))));
};
exports.SearchBarFilter = SearchBarFilter;
SearchBarFilter.propTypes = {
  /** Função de busca a ser executada */
  handleSearchTerm: _propTypes.default.func.isRequired,
  /** Texto do helperText */
  filterHelperText: _propTypes.default.string,
  /** Texto do placeholder do input */
  searchPlaceHolder: _propTypes.default.string,
  /** Lista de opções para o filtro select */
  filterOptions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.string || _propTypes.default.number
  })),
  /** Opção selecionada no filtro */
  defaultFilterOption: _propTypes.default.string,
  /** Função com classes */
  inputWrapperClass: _propTypes.default.string,
  /** Flag de curto-circuito para esconder o widget */
  isToHide: _propTypes.default.bool,
  /**
   * Propriedades para controlar quando esconder um objeto usa a mesma api do Componente do MUI Hidden
   * {@link https://v4.mui.com/components/hidden/#hidden [Detalhes]}
   */
  /** Valor do search */
  value: _propTypes.default.string,
  /** Tamanho definido para esconder props de bottomWidget */
  responsiveHidden: _propTypes.default.shape({
    lgDown: _propTypes.default.bool,
    lgUp: _propTypes.default.bool,
    mdDown: _propTypes.default.bool,
    mdUp: _propTypes.default.bool,
    only: _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])),
    smDown: _propTypes.default.bool,
    smUp: _propTypes.default.bool,
    xlDown: _propTypes.default.bool,
    xlUp: _propTypes.default.bool,
    xsDown: _propTypes.default.bool,
    xsUp: _propTypes.default.bool
  }),
  /** Função responsável por exibir o showSearch em Mobile ao clicar no bottomWidgetProps
   */
  handleShowSearch: _propTypes.default.func,
  /** Função responsável por esconder o showSearch em Mobile ao clicar no bottomWidgetProps
   */
  handleHideSearch: _propTypes.default.func,
  /** Booleano responsável por exibir ou não o drawer com items do filtro, no mobile */
  isShowSearch: _propTypes.default.bool,
  /** Booleano responsável por exibir ou não o Helper Text */
  isShowHelperText: _propTypes.default.bool
};
SearchBarFilter.defaultProps = {
  searchPlaceHolder: 'Buscar...',
  filterHelperText: 'Helper Text',
  filterOptions: [{
    label: '',
    value: ''
  }],
  defaultFilterOption: 'todos',
  inputWrapperClass: null,
  isToHide: false,
  responsiveHidden: {
    lgDown: false,
    lgUp: false,
    mdDown: false,
    mdUp: false,
    only: null,
    smDown: false,
    smUp: false,
    xlDown: false,
    xlUp: false,
    xsDown: false,
    xsUp: false
  },
  handleShowSearch: () => null,
  handleHideSearch: () => null,
  isShowSearch: false,
  value: '',
  isShowHelperText: false
};